module.exports = __webpack_public_path__ + "wafuss1.16fec35a264e772794e542caf1f15b0b.jpg";